// Presence heartbeat: one ping a minute while the tab is visible (live users, sessions, retention
// on the admin dashboard). Anonymous unless signed in; no personal data.
import { api } from "./api";
import { online } from "./env";
import { anonId } from "./identity";
import { playMode } from "./mode";

const sessionId = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random()}`).replace(/-/g, "").slice(0, 32);
const platform = typeof matchMedia === "function" && matchMedia("(pointer: coarse)").matches ? "mobile" : "desktop";

async function beat() {
  if (!online() || document.hidden) return;
  try {
    await api("POST", "/presence", { sessionId, anon: anonId, platform, mode: playMode() }, { timeoutMs: 5000 });
  } catch {
    /* offline is fine */
  }
}

export function startPresence() {
  void beat();
  setInterval(() => void beat(), 60_000);
  document.addEventListener("visibilitychange", () => !document.hidden && void beat());
}
